export default __webpack_public_path__ + "static/media/4f.42537b06.png";